// Mock Foods Data
// Extracted from demo-data/food.ts and other food-related components

export interface FoodEntry {
  id: string;
  user_id: string;
  meal_type: string;
  food_name: string;
  brand: string | null;
  serving_size: number;
  serving_unit: string;
  macros: {
    calories: number;
    carbs: number;
    protein: number;
    fat: number;
    fiber: number;
  };
  logged_at: string;
  created_at: string;
}

export const mockFoods: FoodEntry[] = [
  {
    id: '1',
    user_id: 'demo-user-id',
    meal_type: 'breakfast',
    food_name: 'Oatmeal with berries',
    brand: null,
    serving_size: 1,
    serving_unit: 'bowl',
    macros: {
      calories: 280,
      carbs: 45,
      protein: 8,
      fat: 6,
      fiber: 7
    },
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '2',
    user_id: 'demo-user-id',
    meal_type: 'lunch',
    food_name: 'Grilled chicken salad',
    brand: null,
    serving_size: 1,
    serving_unit: 'bowl',
    macros: {
      calories: 320,
      carbs: 12,
      protein: 25,
      fat: 15,
      fiber: 4
    },
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '3',
    user_id: 'demo-user-id',
    meal_type: 'dinner',
    food_name: 'Salmon with vegetables',
    brand: null,
    serving_size: 1,
    serving_unit: 'plate',
    macros: {
      calories: 380,
      carbs: 25,
      protein: 35,
      fat: 18,
      fiber: 6
    },
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  },
  {
    id: '4',
    user_id: 'demo-user-id',
    meal_type: 'snack',
    food_name: 'Greek yogurt with nuts',
    brand: null,
    serving_size: 1,
    serving_unit: 'cup',
    macros: {
      calories: 200,
      carbs: 15,
      protein: 20,
      fat: 10,
      fiber: 2
    },
    logged_at: new Date().toISOString(),
    created_at: new Date().toISOString()
  }
]; 